<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>     
    <v-row v-if="loading" class="pb-3 px-3">
        <v-col class="text-center">
          <v-progress-linear
            color="info"
            height="5"
            indeterminate
            striped
          ></v-progress-linear>
        </v-col>
    </v-row>
    <v-row v-else class="pl-4 pb-2 mt-1">
      <v-col cols="12" md="6" lg="6">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Promozioni Slots prenotazioni Online
            <v-spacer></v-spacer>
            <v-div class="mr-n5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>                                     
            </v-div> 
          </v-card-title>
          <v-tabs
            class="grey lighten-3 neu-glow"
            v-model="dowId"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="info"></v-tabs-slider>
            <template v-for="(d,di) in dows" >
              <v-tab
                :key=di
                :href="'#'+d"
                class="font-weight-bold"
              >
                {{d}}
              </v-tab>
              <v-tab-item :key=d :id="d" class="mb-1 neu-glow">

                <v-row class="my-n2">
                  <v-col cols="12">
                    <v-sheet >
                      <v-tabs
                        class="neu-glow"
                        v-model="mealId"
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                      >
                        <v-tabs-slider color="info"></v-tabs-slider>
                        <template v-for="(m,mi) in allMeals" >
                          <v-tab
                            :key=mi
                            :href="'#'+m.mealId"
                            class="font-weight-bold mr-3"
                            
                          >
                            {{m.name}} 
                          </v-tab>
                          <v-tab-item :key=m :id="m.mealId" class="my-3 pl-5 mr-3" >
                              <v-row>
                                <v-col  style="max-width:150px">
                                  Slot
                                </v-col>
                                <v-col v-for="(hh,hi) in headersPromo" :key="hi">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <div v-bind="attrs" v-on="on">
                                        {{hh.title}}
                                      </div>
                                    </template>
                                    <span v-html="hh.remarks"></span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                              <template v-for="(s,si) in activeSlots.filter(s => s.DOW==di+1&&s.mealId==m.mealId)">
                                <v-row :key="si" class="px-3" >
                                  <v-col style="max-width:100px">
                                    <v-text-field
                                      label=""
                                      v-model="s.slotName"
                                      name="slot"
                                      outlined
                                      readonly
                                      dense
                                      reverse
                                    ></v-text-field>
                                  </v-col>
                                  <v-col>
                                    <v-text-field
                                      label=""
                                      v-model="s.bonus"
                                      name="bonus"
                                      :id="s.slotId"
                                      outlined
                                      dense
                                      counter="15"
                                      type="text"
                                      @input.native="save"
                                      style="max-width:200px">
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                              </template>
                          </v-tab-item>
                        </template>
                      </v-tabs>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
      <!--
      <v-col cols="12" md="8" lg="6">
        <v-card class="neu-glow px-4 pb-4 mr-4">
          <v-card-title>
            Premi Recensioni
            <v-spacer></v-spacer>
            <v-div class="mr-n5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editItem()">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Nuova</span>
              </v-tooltip>                  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData2()">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>                                     
            </v-div> 
          </v-card-title>
          <v-card-text>
            <v-data-table
              fixed-header
              :headers="headers"
              :items="prizes||[]"
              hide-default-footer
              :items-per-page=500
              :loading="loading||loading_refresh"
              no-data-text="Nessun dato presente in archivio"
              no-results-text="Nessun Risultato estratto"
              loading-text="Consultazione archivio: attendi..."
            >
              <template v-slot:[`item.remarks`]="{ item }">
                <v-tooltip top max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                      <v-icon color="success">mdi-message-text</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="item.remarks"></span>
                </v-tooltip>                        
              </template>

              <template v-slot:[`item.active`]="{ item }">
                <v-simple-checkbox
                  v-model="item.active"
                  color="info"
                  style="pointer-events: none"
                ></v-simple-checkbox>
              </template>

              <template v-slot:[`item.validity`]="{ item }">
                <div>{{item.validity}}</div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="warning"
                        class="mr-2"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>                
                  </template>
                  <span>Modifica</span>
                </v-tooltip>
                
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="error"
                        class="mr-2"
                        @click="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>                
                  </template>
                  <span>Elimina</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="error"
                        class="mr-2"
                        @click="showItem(item)"
                      >
                        mdi-eye
                      </v-icon>                
                  </template>
                  <span>Visualizza</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-show="selectedItem">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Premi Recensioni
            <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>               
          </v-card-title>
        </v-card>          
      </v-col>
      -->
    </v-row>  
    <v-dialog v-model="dialog_edit" max-width="400" class="pb-3" v-if="editedItem">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              {{editedItem.value?'Modifica Sala':'Crea Sala'}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="hash==JSON.stringify(editedItem)" :loading="loading_update" @click="saveItem('save')">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_edit=false" fab small class="neu-glow" :disabled="hash!=JSON.stringify(editedItem)"  v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col cols="12">
                  <v-text-field            
                    counter
                    label="Nome"
                    outlined
                    v-model="editedItem.text"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select           
                    counter
                    label="Area"
                    outlined
                    :items="allLocationsTable"
                    v-model="editedItem.locationId"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" v-show="editedItem.value" class="d-flex justify-center mt-n3">
                <v-switch
                    v-model="editedItem.active"
                    inset
                    :label="editedItem.active?'Attiva':'Non Attiva'"
                ></v-switch>
                </v-col>                                               
                <v-col cols="6">
                  <v-text-field
                    label="Ordinamento"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.sortOrder"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Colonne"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.cols"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                                                                
            </v-row>
        </v-card>
    </v-dialog>  
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="6" cols="12">
                    <p>
                        Per ogni <strong>Slot</strong> di <strong>Ogni Giorno</strong>, di ogni <strong>Turno</strong> e per ogni <strong>Area</strong>, è possibile impostare vari parametri:
                        <ul>
                          <li>
                            Il numero massimo di Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                          </li>
                          <li>
                            La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                          </li>
                          <li>
                            L'orario dal quale non vengno più accettate prenotazioni per il giorno stesso, ma il sistema invita a chiamare il locale e parlare con lo staff
                          </li>
                          <li>Se inviare o meno la richiesta di rilascio Feedback</li>
                        </ul>
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                  <p>
                    Per velocizzare le operazioni di inserimento, 
                  </p>
                  <p>
                    Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                  </p>
                  <p>
                    Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                  </p>
                </v-col>
                <v-col cols="12">
                  <p color="error--text">
                    <strong>Nota:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione e bypassare ogni blocco.
                  </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_edit:false,
      dialog_delete:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:null,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      mealId:null,
      tabId:null,
      dowId:null,
      slotId:null,
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      dows:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headersPromo:[
              {title:"Omaggio",remarks:"Omaggio (per persona) offerto"},
              ],
      headers: [
                { text: 'Attiva',       value: 'active',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Nome',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'dal/al',       value: 'validity',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Esigibilità',  value: 'duration',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Esclusi',      value: 'excludedDoW', align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],              
      allMeals:null,
      selectedItem:null
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
    this.getData2()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(289,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 1000), 
    showItem(i)
    {
      this.selectedItem=i;
    },  
    editItem(f=null)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem(a)
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='deleteItem'
          this.editedItem.erase=1;
        }
        else
        {
          action='saveItem';
        }
        let payload={"action":action,"table":"Locations","payload":JSON.stringify(this.editedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.$root.$emit('onupdateLocations', null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        this.editedItem={...this.emptyItem}
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(355,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(366,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async getData2(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"AllPrizes_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.prizes=res.data.payloads.allPrizes;

                    console.log(315,this.prizes)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(383,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;
            
            if (res.data.message)
            {
                console.log(392);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(401);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>